import React from 'react';
import './input.scss';
import PropTypes from 'prop-types';
import OtpInput from 'react-otp-input';
import Icon from '../Icon/Icon';

const INPUT_TYPES = {
  TEXT: 'text',
  NUMBER: 'number',
  OTP: 'otp',
  EMAIL: 'email',
  MOBILE: 'mobile',
  SEARCH: 'search',
  PASSWORD: 'password',
  TEL: 'tel',
};

class Input extends React.Component {
  _allowOnlyDigits = value =>
    !`${value}`.length || (!isNaN(value) && new RegExp('^[0-9]+$').test(value));

  _inputValidations = input => {
    const { onInputValidation = null, allowOnlyDigits = false } = this.props;
    let isInputValid = true;
    if (onInputValidation) isInputValid = onInputValidation(input);
    if (isInputValid && allowOnlyDigits)
      isInputValid = this._allowOnlyDigits(input);
    return isInputValid;
  };

  _getNewState = value => {
    const { name } = this.props;
    const newState = {};
    newState[name] = value;
    return newState;
  };

  _onChange = ev => {
    const value = ev.target.value;
    if (this._inputValidations(value)) {
      this.props.onChange(this._getNewState(value), ev);
    }
  };
  _getType = type => {
    if ([INPUT_TYPES.MOBILE, INPUT_TYPES.OTP].indexOf(type) > -1) {
      return INPUT_TYPES.TEL;
    }
    return type;
  };

  _updateOTP = otp => {
    this.props.onChange(this._getNewState(otp));
  };

  _clearText = () => {
    this.props.onChange(this._getNewState(''));
  };

  _onBlur = ev => {
    const value = ev.target.value;
    this.props.onBlur(this._getNewState(value), ev);
  };

  render() {
    const {
      type,
      prefix,
      suffix,
      name,
      placeholder,
      value,
      maxLength,
      required,
      className,
      autoFocus = false,
      clearText,
      autoComplete = 'off',
      search,
      hasError,
      errorMsg,
      disabled,
      dataPrivate,
    } = this.props;
    const inputProps = {
      onChange: this._onChange,
      placeholder,
      value,
      type: this._getType(type),
      name,
      maxLength,
      required,
      autoFocus,
      autoComplete,
      disabled,
    };
    if (this.props.onBlur) inputProps.onBlur = this._onBlur;
    if (dataPrivate) inputProps['data-private'] = dataPrivate;
    if (prefix) {
      return (
        <div className="input-group">
          <div className="input-group--prefix">{prefix}</div>
          <div className="input-group--separator"></div>
          <div className="input-group--input">
            <input {...inputProps} />
          </div>
        </div>
      );
    }
    if (suffix) {
      return (
        <div>
          <div
            className={`input-group ${
              hasError ? 'input-group-with-error' : ''
            }`}
          >
            <div className="input-group--input">
              <input {...inputProps} />
            </div>
            <div className="input-group--separator" />
            <div className="input-group--suffix">{suffix}</div>
          </div>
          {hasError && errorMsg && (
            <div className="input-error-message">{errorMsg}</div>
          )}
        </div>
      );
    }
    if (type === 'otp') {
      return (
        <div className="otp-input-box">
          <OtpInput
            value={value}
            shouldAutoFocus={true}
            onChange={this._updateOTP}
          />
        </div>
      );
    }
    if (clearText) {
      return (
        <div className={`input-group ${className} search-box`}>
          <div className="input-group--input">
            <input {...inputProps} />
          </div>
          <div className="input-group--clear-text-suffix">
            {search ? (
              <Icon size={20} class="icon-back-bar-search" />
            ) : (
              <Icon
                size={20}
                class="icon-common-close"
                onClick={this._clearText}
              />
            )}
          </div>
        </div>
      );
    }
    return (
      <React.Fragment>
        <input
          {...inputProps}
          className={`${className} ${hasError ? 'input-with-error' : ''}`}
        />
        {hasError && errorMsg && (
          <div className="input-error-message">{errorMsg}</div>
        )}
      </React.Fragment>
    );
  }
}

Input.propTypes = {
  type: PropTypes.oneOf([
    'text',
    'number',
    'otp',
    'email',
    'mobile',
    'search',
    'password',
  ]).isRequired,
  prefix: PropTypes.string,
  suffix: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  onChange: PropTypes.func.isRequired, // return (json, e);
  value: PropTypes.any, //Its the state in component you bind the text to.
  placeholder: PropTypes.string,
  name: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  maxLength: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  required: PropTypes.bool,
  className: PropTypes.string,
  autoFocus: PropTypes.bool,
  search: PropTypes.bool,
  autoComplete: PropTypes.oneOf(['off', 'on']),
  errorMsg: PropTypes.string,
  hasError: PropTypes.bool,
  onBlur: PropTypes.func,
  onInputValidation: PropTypes.func,
  allowOnlyDigits: PropTypes.bool,
  dataPrivate: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

export default Input;
